import { createContext } from 'react';

/**
 * When true, AI buttons below render as the labeled "Gerar insights" button instead of icon-only.
 * Lets a page (e.g. Microdados) switch the style of shared cards without prop drilling.
 */
export const AiAssistantButtonLabeledContext = createContext(false);
